import React, {Fragment} from "react";
import {Link, useMediaQuery, useTheme} from "@mui/material";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

const CategoriesLists = ({categories, onClick}) => {
  const rows = [];

  const theme = useTheme();
  const chunkSize = useMediaQuery(theme.breakpoints.up("md")) ? 3 : 1;

  for (let i = 0; i < categories.length; i += chunkSize) {
    const categoriesChunk = categories.slice(i, i + chunkSize);

    /* first level */
    rows.push(
      <Grid key={"categories-lists__root__container__" + i} container spacing={2}>
        {categoriesChunk.map((rootCategory, i) => (
          <Grid item key={"categories-lists__root__" + i} xs={12} md={4}>
            <Typography variant="h5" sx={{fontSize: "20px"}}>
              {rootCategory.datasetIdentifiers?.length > 0 ? (
                <Link
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    onClick([rootCategory.id]);
                  }}
                  style={{cursor: "pointer"}}
                >
                  {rootCategory.label} ({rootCategory.datasetIdentifiers.length})
                </Link>
              ) : (
                rootCategory.label
              )}
            </Typography>
          </Grid>
        ))}
      </Grid>
    );

    const fontSizes = [18, 16, 15, 14];

    /* recursively renders subtree of categories */
    const Subtree = ({root, depth, fontSizes, parentPath = []}) =>
      root.childrenCategories &&
      root.childrenCategories.length > 0 && (
        <div
          sx={theme => ({
            height: "100%",
            backgroundColor: theme.palette.background.default
          })}
        >
          <List
            sx={theme => ({
              paddingLeft: theme.spacing(1),
              paddingRight: theme.spacing(1)
            })}
          >
            {root.childrenCategories.map((child, i) => (
              <Fragment key={"categories-lists__subtree__depth-" + depth + "__" + i}>
                <ListItem sx={{padding: "0px"}}>
                  <ListItemText
                    primary={
                      <Typography sx={{fontSize: fontSizes[0]}}>
                        {child.datasetIdentifiers?.length > 0 ? (
                          <Link
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              onClick([...parentPath, root.id, child.id]);
                            }}
                            style={{cursor: "pointer"}}
                          >
                            {child.label} ({child.datasetIdentifiers.length})
                          </Link>
                        ) : (
                          child.label
                        )}
                      </Typography>
                    }
                  />
                </ListItem>
                {/* recursion on subtree of child category */}
                {depth > 1 && (
                  <Subtree
                    root={child}
                    depth={depth - 1}
                    fontSizes={fontSizes.slice(1)}
                    parentPath={[...parentPath, root.id]}
                  />
                )}
              </Fragment>
            ))}
          </List>
        </div>
      );

    /* 4 levels subtree */
    rows.push(
      <Grid key={"categories-lists__subtree__container__" + i} container spacing={2}>
        {categoriesChunk.map((rootCategory, i) => (
          <Grid item key={"categories-lists__subtree__" + i} xs={12} md={4} sx={{position: "relative"}}>
            <Subtree root={rootCategory} depth={4} fontSizes={fontSizes} />
          </Grid>
        ))}
      </Grid>
    );
  }

  return rows;
};

export default CategoriesLists;
